import React, { useState, useEffect } from 'react';
import { updateUserProfile } from '../api/ideas';

function SettingsModal({ closeModal, user, token }) {
  const [username, setUsername] = useState(user?.username || '');
  const [displayName, setDisplayName] = useState(user?.display_name || '');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setUsername(user.username);
      setDisplayName(user.display_name || '');
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password && password !== passwordConfirm) {
      setError('Passwords do not match');
      return;
    }
    try {
      await updateUserProfile(
        {
          username,
          display_name: displayName,
          password: password || undefined,
        },
        token
      );
      alert('Profile updated successfully!');
      closeModal();
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fade-in">
      <div className="bg-[var(--bg-secondary)] p-6 rounded-xl shadow-lg max-w-md w-full max-h-[90vh] overflow-y-auto animate-scale-in">
        <h3 className="text-lg font-semibold mb-4 text-[var(--text-primary)]">Settings</h3>
        {error && (
          <div className="bg-danger-light border text-danger px-4 py-2 rounded-lg mb-4 animate-shake">
            {error}
          </div>
        )}
        
        {/* Profile Settings Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm text-[var(--secondary)] mb-1 font-medium">Username</label>
            <input
              type="text"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200 focus-glow"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm text-[var(--secondary)] mb-1 font-medium">Display Name</label>
            <input
              type="text"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200 focus-glow"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm text-[var(--secondary)] mb-1 font-medium">New Password</label>
            <input
              type="password"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200 focus-glow"
              placeholder="Leave blank to keep current"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm text-[var(--secondary)] mb-1 font-medium">Confirm Password</label>
            <input
              type="password"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200 focus-glow"
              placeholder="Confirm new password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </div>

          <div className="flex gap-2 mt-4">
            <button
              type="submit"
              className="px-4 py-2 bg-[var(--primary)] text-white rounded-lg text-sm hover:bg-[var(--secondary)] transition-all duration-200 transform hover:scale-105 active:scale-95 button-magical ripple"
            >
              Save Profile Changes
            </button>
            <button
              type="button"
              className="px-4 py-2 bg-[var(--secondary)] bg-opacity-20 text-[var(--tex-secondary)] rounded-lg text-sm hover:bg-[var(--secondary)] hover:text-white transition-all duration-200 transform hover:scale-105 active:scale-95"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SettingsModal;